import { MutableRef, useEffect, useRef } from 'preact/hooks';

export enum Navigation {
  UP,
  DOWN,
  ENTER,
};

export type SearchBoxProps = {
  onNavigate?: (direction: Navigation) => void,
  onSearch: (query: string) => void,
  inputRef?: MutableRef<HTMLInputElement | null>,
};

export function SearchBox(props: SearchBoxProps) {
  const { onNavigate, onSearch, inputRef } = props;
  const _ref = useRef<HTMLInputElement>(null);

  function searchKeyDown(evt: KeyboardEvent) {
    if (evt.key === 'ArrowDown') {
      onNavigate?.(Navigation.DOWN);
      evt.preventDefault();
    }
    if (evt.key === 'ArrowUp') {
      onNavigate?.(Navigation.UP);
      evt.preventDefault();
    }
    if (evt.key === 'Enter') {
      onNavigate?.(Navigation.ENTER);
      evt.preventDefault();
    }
  }

  function inputRefReceived(ref: HTMLInputElement | null) {
    if (inputRef) {
      inputRef.current = ref;
    }
    ref?.addEventListener('keydown', searchKeyDown);
    _ref.current = ref;
    return () => {
      if (inputRef) {
        inputRef.current = null;
      }
      _ref.current = null;
      ref?.removeEventListener('keydown', searchKeyDown);
    }
  }

  useEffect(() => {
    if (_ref.current) {
      onSearch(_ref.current.value);
    }
  }, []);

  function onInput(evt: Event) {
    const value = (evt.currentTarget as HTMLInputElement).value;
    onSearch(value);
  }

  return <div class="searchbox-container">
          <input type="text" class="searchbox" placeholder="Type to begin searching"
            onInput={onInput} ref={inputRefReceived} />
          <span class="key-shortcut">Ctrl + K</span>
        </div>;
}
